<template>
    <div>
        <h5 class="heading-1">
            <span>CONFIRMAÇÃO DA DOCUMENTAÇÃO</span>
        </h5>
        <b-row>
            <b-col>
                <b-form-group>
                    <label>
                        <strong>Você está de posse da comprovação do serviço?</strong>
                    </label>
                    <b-form-radio-group
                        v-model="docComprovacao01"
                        :disabled="atesto.codSituacao != 0"
                    >
                        <b-form-radio value="0">
                            <strong>
                                <span class="text-danger">NÃO</span>
                            </strong>
                        </b-form-radio>
                        <b-form-radio value="1">
                            <strong>
                                <span class="text-primary">SIM</span>
                            </strong>
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-form-group>
                    <label>
                        <strong>A comprovação atende aos requisitos exigidos pelo Sebrae?</strong>
                    </label>
                    <b-form-radio-group
                        v-model="docComprovacao02"
                        :disabled="atesto.codSituacao != 0"
                    >
                        <b-form-radio value="0">
                            <strong>
                                <span class="text-danger">NÃO</span>
                            </strong>
                        </b-form-radio>
                        <b-form-radio value="1">
                            <strong>
                                <span class="text-primary">SIM</span>
                            </strong>
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
	props: {
		value: {
			type: Object,
			default: () => {}
		},

		atesto: {
			type: Object,
			default: () => {}
		}
	},

	data() {
		return {
			docComprovacao01: 0,
			docComprovacao02: 0
		}
	},

	created() {
		this.docComprovacao01 = this.value.comprovacao01 ? 1 : 0
		this.docComprovacao02 = this.value.comprovacao02 ? 1 : 0
	},

	watch: {
		docComprovacao01() {
			this.atualizar()
		},

		docComprovacao02() {
			this.atualizar()
		}
	},

	methods: {
		atualizar() {
			let retorno = {
				comprovacao01: this.docComprovacao01 == 1 ? true : false,
				comprovacao02: this.docComprovacao02 == 1 ? true : false
			}
			this.$emit('input', retorno)
		}
	}
}
</script>
